import React from 'react'
import { Chip } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    categoryTag: {
        backgroundColor: theme.palette.warning.main,
        color: theme.palette.warning.contrastText,
        fontWeight: 500
    },
}));

export const CategoryTag = ({ content, size = 'small' }) => {
    const classes = useStyles();
    return (
        <Chip
            label={content}
            className={classes.categoryTag}
            size={size}
        />
    )
} 